/*
 * mh-zaun-konfigurator.js — myHarry Sichtschutz-Konfigurator (neue PDP)
 *
 * Modell: Composite. Jede Komponente ist ein echtes Produkt/Variante aus dem
 * Metaobjekt "sichtschutz_system"; der Konfigurator berechnet Stückliste + Preis
 * und legt alle Positionen gruppiert (gemeinsame Konfigurations-ID) in den Warenkorb.
 *
 * Je Zaunfeld wählbar: Profil/Farbe (WPC-Farben + ALU-Profile, Metaobjekt "sichtschutz_profil"),
 * Höhe (Elemente), Designleisten, Dekorpaneel, Leistenfarbe. Designleisten und Dekorpaneel
 * lassen sich in der Vorschau per Drag & Drop (Pointer Events, auch Touch) verschieben.
 *
 * Vorschau: Layer-Rendering der freigestellten PNGs (1000×1000, gleiche Achsen) auf <canvas>.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mhzk]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section');
  var dataEl = document.getElementById('mhzk-data-' + sectionId);
  var preview = document.querySelector('[data-mhzk-preview]');
  if (!dataEl || !preview) return;

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('mhzk: JSON', e); return; }
  var S = D.sys;

  /* ─────────────────── Helpers ─────────────────── */
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: D.currency || 'EUR' });
  var money = function (c) { return fmt.format((c || 0) / 100); };
  var m = function (mm) { return (mm / 1000).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m'; };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9äöüß]/g, ''); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function variantFor(list, colorName) {
    if (!list || !list.length) return null;
    var c = norm(colorName);
    var hit = list.filter(function (v) { return c && norm(v.title).indexOf(c) !== -1; })[0];
    if (hit) return hit;
    hit = list.filter(function (v) { return /^default title$/i.test(v.title); })[0];
    return hit || (list.length === 1 ? list[0] : null);
  }
  function postVariantFor(list, neededCm) {
    if (!list || !list.length) return null;
    var parsed = list.map(function (v) {
      var mm = String(v.title).match(/(\d+(?:[.,]\d+)?)\s*(cm|m)\b/i);
      var cm = mm ? parseFloat(mm[1].replace(',', '.')) * (mm[2].toLowerCase() === 'm' ? 100 : 1) : NaN;
      return { v: v, cm: cm };
    }).filter(function (x) { return !isNaN(x.cm); }).sort(function (a, b) { return a.cm - b.cm; });
    if (!parsed.length) return list[0];
    var ok = parsed.filter(function (x) { return x.cm >= neededCm; })[0];
    return (ok || parsed[parsed.length - 1]).v;
  }

  /* ─────────────────── Katalog ─────────────────── */
  var designChoices = String(S.designOptions || '0,3,alle').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  var hasRailsProduct = D.rails && D.rails.variants && D.rails.variants.length;
  var hasDesign = D.design && D.design.variants && D.design.variants.length;
  var hasPaneele = D.paneele && D.paneele.length;
  var farben = D.farben || [];

  // Profile (WPC-Farben + ALU-Profile). Fallback: das am Produkt hinterlegte Profil.
  var profiles = (D.profile || []).filter(function (p) { return p.variants && p.variants.length; }).sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
  if (!profiles.length && D.profil && D.profil.variants && D.profil.variants.length) {
    profiles = [{ handle: 'default', name: D.product.title, material: S.typ || 'wpc', hex: '#888', img: D.profil.img, setSize: S.setSize, setHasRails: !!S.setHasRails, elemH: S.elemH, productId: D.profil.productId, title: D.profil.title, variants: D.profil.variants }];
  }
  function profOf(handle) { return profiles.filter(function (p) { return p.handle === handle; })[0] || profiles[0]; }
  var defaultProfile = (profiles.filter(function (p) { return D.profil && p.productId === D.profil.productId; })[0] || profiles[0] || {}).handle;

  var defaultColor = (function () {
    var pf = norm(D.product.farbe);
    var hit = farben.filter(function (f) { return pf && norm(f.name) === pf; })[0];
    return (hit || farben[0] || {}).handle || null;
  })();
  function colorObj(handle) { return farben.filter(function (c) { return c.handle === handle; })[0] || farben[0] || { img: {} }; }
  function paneelObj(handle) { return (D.paneele || []).filter(function (p) { return p.handle === handle; })[0]; }
  function paneelImg(pn, colorHandle) {
    if (!pn) return null;
    var key = norm(colorObj(colorHandle).name);
    return pn.img[key] || pn.img.anthrazit || pn.img.seidengrau || null;
  }

  /* ─────────────────── State ─────────────────── */
  var state = { fields: [], active: 0, same: true, montage: 'aufschrauben', postColor: defaultColor, railColor: defaultColor };

  function fixedElements(f) { var p = profOf(f.profil); return p && p.setHasRails ? (p.setSize || S.maxEl) : 0; }
  function elemH(f) { var p = profOf(f.profil); return (p && p.elemH) || S.elemH; }
  function fieldRailsFromSet(f) { var p = profOf(f.profil); return !!(p && p.setHasRails); }
  // ALU-Lamellen-Set: feste Lamellenzahl/-höhe laut Stückliste, keine Designleisten/Paneele
  function isLamellen(f) { var p = profOf(f.profil); return !!(p && p.setHasRails && p.lamellen > 0 && p.lamellenH > 0); }

  function newField(src) {
    var f = {
      profil: src ? src.profil : defaultProfile,
      el: src ? src.el : clamp(8, S.minEl, S.maxEl),
      designN: src ? src.designN : (parseInt(designChoices[0], 10) || 0),
      designSlots: src ? src.designSlots.slice() : [],
      paneel: src ? src.paneel : null,
      paneelN: src ? src.paneelN : 0,
      paneelPos: src ? src.paneelPos.slice() : [],   // 0-basiert von unten, ein Eintrag je Paneel
      saved: false
    };
    normalizeField(f, !src);
    return f;
  }
  // Konsistenz: feste Elementzahl bei ALU-Sets, Designleisten-Slots & Paneel-Position im gültigen Bereich
  function normalizeField(f, recalcSlots) {
    var fx = fixedElements(f);
    if (fx) f.el = fx; else f.el = clamp(f.el, S.minEl, S.maxEl);
    if (!hasDesign || isLamellen(f)) f.designN = 0;
    f.designN = clamp(f.designN || 0, 0, Math.max(0, f.el - 1));
    f.designSlots = (f.designSlots || []).filter(function (g, i, a) { return g >= 1 && g <= f.el - 1 && a.indexOf(g) === i; }).sort(function (a, b) { return a - b; });
    if (recalcSlots || f.designSlots.length !== f.designN) f.designSlots = spread(f.designN, f.el - 1);
    if (f.paneel && (!paneelObj(f.paneel) || isLamellen(f))) f.paneel = null;
    if (!f.paneel) f.paneelN = 0;
    f.paneelN = clamp(f.paneelN || 0, 0, f.el);
    if (f.paneelN === 0) f.paneel = null;
    f.paneelPos = (f.paneelPos || []).filter(function (g, i, a) { return g >= 0 && g <= f.el - 1 && a.indexOf(g) === i; }).sort(function (a, b) { return a - b; });
    if (recalcSlots || f.paneelPos.length !== f.paneelN) f.paneelPos = spreadPaneele(f);
  }
  // n Positionen gleichmäßig auf 1..max verteilen
  function spread(n, max) {
    var out = [];
    if (n <= 0 || max <= 0) return out;
    if (n >= max) { for (var i = 1; i <= max; i++) out.push(i); return out; }
    for (var k = 1; k <= n; k++) out.push(Math.round(k * (max + 1) / (n + 1)));
    return out.filter(function (v, i, a) { return v >= 1 && v <= max && a.indexOf(v) === i; });
  }
  // Paneel-Positionen (von unten): 1 Paneel an Standardposition von oben, mehrere gleichmäßig verteilt
  function spreadPaneele(f) {
    var n = f.paneelN, el = f.el;
    if (n <= 0) return [];
    if (n === 1) return [el - clamp(S.paneelPos || 2, 1, el)];
    if (n >= el) { var all = []; for (var i = 0; i < el; i++) all.push(i); return all; }
    return spread(n, el).map(function (posFromTop) { return el - posFromTop; }).sort(function (a, b) { return a - b; });
  }
  function designCount(f) { return f.designSlots.length; }
  function fieldHeightMm(f) { return 2 * S.railH + f.el * elemH(f) + designCount(f) * S.designH; }
  function totalLenMm() { var n = state.fields.length; return n * S.elemW + (n + 1) * S.postW; }
  function copyInto(dst, src) {
    dst.profil = src.profil; dst.el = src.el; dst.designN = src.designN; dst.designSlots = src.designSlots.slice();
    dst.paneel = src.paneel; dst.paneelN = src.paneelN; dst.paneelPos = src.paneelPos.slice(); normalizeField(dst, false);
  }
  state.fields.push(newField());

  /* ─────────────────── Stückliste ─────────────────── */
  function buildBom() {
    var lines = {};
    function add(key, v, title, qty) {
      if (!v || !qty) return;
      if (!lines[key]) lines[key] = { id: v.id, title: title, q: 0, price: v.price, compare: v.compare || v.price, available: v.available !== false };
      lines[key].q += qty;
    }
    var problems = [], profilesNeeded = {}, spare = 0;
    state.fields.forEach(function (f) {
      var p = profOf(f.profil);
      if (!p) { problems.push('Profil nicht hinterlegt'); return; }
      var nPaneel = f.paneel ? f.paneelPos.length : 0;
      if (p.setHasRails) {
        add('profil:' + p.handle, p.variants[0], p.title, 1); // fertiges Feld-Set
      } else {
        profilesNeeded[p.handle] = (profilesNeeded[p.handle] || 0) + f.el - nPaneel;
      }
      var rc = colorObj(state.railColor);
      if (hasRailsProduct && !p.setHasRails) {
        var rv = variantFor(D.rails.variants, rc.name);
        if (rv) add('rails:' + rv.id, rv, D.rails.title + ' · ' + rc.name, 1);
        else problems.push('Start-/Abschlussleiste in ' + rc.name + ' nicht gefunden');
      }
      var dc = designCount(f);
      if (dc > 0) {
        var dv = variantFor(D.design.variants, rc.name);
        if (dv) add('design:' + dv.id, dv, D.design.title + ' · ' + rc.name, dc);
        else problems.push('Designleiste in ' + rc.name + ' nicht gefunden');
      }
      if (nPaneel > 0) {
        var pn = paneelObj(f.paneel);
        var pv = variantFor(pn.variants, rc.name);
        if (pv) add('paneel:' + pv.id, pv, pn.title + (pn.variants.length > 1 ? ' · ' + rc.name : ''), nPaneel);
        else problems.push('Dekorpaneel ' + pn.name + ' nicht gefunden');
        if (pn.verbinder && pn.verbinder.variants && pn.verbinder.variants.length) {
          var vv = variantFor(pn.verbinder.variants, rc.name);
          if (vv) add('verb:' + vv.id, vv, pn.verbinder.title + ' · ' + rc.name, nPaneel);
        }
      }
    });
    Object.keys(profilesNeeded).forEach(function (h) {
      var p = profOf(h), setSize = Math.max(1, p.setSize || 1);
      var sets = Math.ceil(profilesNeeded[h] / setSize);
      add('profil:' + h, p.variants[0], p.title, sets);
      spare += sets * setSize - profilesNeeded[h];
    });
    // Pfosten: N+1, Höhe je Pfosten = max. Nachbarfeld (+ Zugabe beim Einbetonieren)
    var pc = colorObj(state.postColor), posts = 0;
    if (pc && pc.post && pc.post.variants && pc.post.variants.length) {
      var n = state.fields.length;
      for (var i = 0; i <= n; i++) {
        var left = i > 0 ? fieldHeightMm(state.fields[i - 1]) : 0;
        var right = i < n ? fieldHeightMm(state.fields[i]) : 0;
        var needCm = Math.ceil((Math.max(left, right) + (S.bodenabstand || 0)) / 10) + (state.montage === 'einbetonieren' ? (S.einbetonZugabe || 50) : 0);
        var v = postVariantFor(pc.post.variants, needCm);
        if (v) { add('post:' + v.id, v, 'Pfosten ' + pc.name + ' ' + v.title, 1); posts++; }
      }
    } else problems.push('Pfosten-Produkt nicht hinterlegt');
    if (state.montage === 'aufschrauben' && posts) {
      if (D.konsole) add('konsole', D.konsole, D.konsole.title, posts);
      if (D.bolzen) add('bolzen', D.bolzen, D.bolzen.title, posts);
    }
    var arr = Object.keys(lines).map(function (k) { return lines[k]; });
    var total = 0, compare = 0, unavailable = false;
    arr.forEach(function (l) { total += l.q * l.price; compare += l.q * l.compare; if (!l.available) unavailable = true; });
    return { lines: arr, total: total, compare: compare, problems: problems, posts: posts, spare: spare, unavailable: unavailable };
  }

  /* ─────────────────── Bilder ─────────────────── */
  var imgCache = {};
  function loadImg(url) {
    if (!url) return Promise.resolve(null);
    if (imgCache[url]) return imgCache[url].p;
    var im = new Image(); im.crossOrigin = 'anonymous';
    var entry = { img: im, bbox: null };
    entry.p = new Promise(function (res) {
      im.onload = function () { entry.bbox = detectBbox(im); res(entry); };
      im.onerror = function () { res(null); };
    });
    im.src = url; imgCache[url] = entry;
    return entry.p;
  }
  function detectBbox(im) {
    try {
      var W = im.naturalWidth, H = im.naturalHeight, sc = 250 / Math.max(W, H);
      var c = document.createElement('canvas'); c.width = Math.ceil(W * sc); c.height = Math.ceil(H * sc);
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, c.width, c.height);
      var d = x.getImageData(0, 0, c.width, c.height).data, minx = 1e9, miny = 1e9, maxx = -1, maxy = -1;
      // Hintergrund = transparent ODER eingebackenes Schachbrett (weiß/hellgrau, unbunt)
      for (var y = 0; y < c.height; y++) for (var xx = 0; xx < c.width; xx++) {
        var o = (y * c.width + xx) * 4, r = d[o], g = d[o + 1], bl = d[o + 2], a = d[o + 3];
        if (a <= 20) continue;
        var mx = Math.max(r, g, bl), mn = Math.min(r, g, bl);
        if (mx - mn < 12 && mn >= 205) continue;
        if (xx < minx) minx = xx; if (xx > maxx) maxx = xx; if (y < miny) miny = y; if (y > maxy) maxy = y;
      }
      if (maxx < 0) return null;
      return { x: Math.floor(minx / sc), y: Math.floor(miny / sc), w: Math.ceil((maxx - minx + 1) / sc), h: Math.ceil((maxy - miny + 1) / sc) };
    } catch (e) { return null; }
  }
  function bboxOf(entry, role, mmH) {
    if (entry && entry.bbox) return entry.bbox;
    var W = entry ? entry.img.naturalWidth : 1000, H = entry ? entry.img.naturalHeight : 1000;
    var h = Math.max(4, Math.round(mmH * (W * 0.907) / S.elemW));
    switch (role) {
      case 'postL': return { x: 0, y: Math.round(H * 0.03), w: Math.round(W * 0.064), h: Math.round(H * 0.97) };
      case 'postR': return { x: Math.round(W * 0.947), y: Math.round(H * 0.03), w: Math.round(W * 0.053), h: Math.round(H * 0.97) };
      case 'start': return { x: Math.round(W * 0.046), y: Math.round(H * 0.958), w: Math.round(W * 0.908), h: h };
      case 'end': return { x: Math.round(W * 0.046), y: Math.round(H * 0.055), w: Math.round(W * 0.908), h: h };
      default: return { x: Math.round(W * 0.046), y: Math.round(H / 2 - h / 2), w: Math.round(W * 0.908), h: h };
    }
  }
  function assetsFor(f) {
    var rc = colorObj(state.railColor), pc = colorObj(state.postColor), p = profOf(f.profil) || {};
    var list = [p.img, rc.img.start, rc.img.end, pc.img.postL, pc.img.postR];
    if (designCount(f) > 0) list.push(rc.img.design);
    if (f.paneel) list.push(paneelImg(paneelObj(f.paneel), state.railColor));
    return list.filter(Boolean);
  }
  function preload(fields) {
    var urls = {};
    fields.forEach(function (f) { assetsFor(f).forEach(function (u) { urls[u] = 1; }); });
    return Promise.all(Object.keys(urls).map(loadImg));
  }

  /* ─────────────────── Rendering ─────────────────── */
  // Zeichnet ein Feld und liefert Layout-Infos (für Drag & Drop): Elemente + Zwischenräume in px
  function drawField(ctx, f, x0, yBase, sc) {
    var rc = colorObj(state.railColor), p = profOf(f.profil) || {};
    var pxW = S.elemW * sc, y = yBase, eh = elemH(f);
    var layout = { elems: [], gaps: [] };
    function slab(url, role, mmH) {
      var e = imgCache[url]; var h = mmH * sc; y -= h;
      if (!e || !e.img.naturalWidth) return;
      var b = bboxOf(e, role, mmH);
      try { ctx.drawImage(e.img, b.x, b.y, b.w, b.h, x0, y, pxW, h); } catch (err) {}
    }
    slab(rc.img.start, 'start', S.railH);
    // ALU-Lamellen-Sets: n Lamellen mit Abstandshaltern gleichmäßig auf die Feldhöhe verteilt (laut Stückliste)
    if (isLamellen(f)) {
      var n = p.lamellen, lh = p.lamellenH, contentMm = f.el * eh, pitch = contentMm / n;
      var e = imgCache[p.img], b = e && e.img.naturalWidth ? bboxOf(e, 'elem', lh) : null;
      var bottom = y;
      for (var k = 0; k < n; k++) {
        var yb = bottom - k * pitch * sc;                 // Unterkante der Lamelle
        var hpx = lh * sc, yt = yb - hpx;
        if (lh <= pitch) yt = yb - (pitch - lh) / 2 * sc - hpx; // mittig im Raster, Spalt sichtbar
        if (b) { try { ctx.drawImage(e.img, b.x, b.y, b.w, b.h, x0, yt, pxW, hpx); } catch (err) {} }
      }
      y = bottom - contentMm * sc;
      slab(rc.img.end, 'end', S.railH);
      layout.height = yBase - y;
      return layout;
    }
    var pn = f.paneel ? paneelObj(f.paneel) : null;
    for (var i = 0; i < f.el; i++) {
      if (i > 0) {
        if (f.designSlots.indexOf(i) !== -1) { layout.gaps.push({ g: i, y: y - S.designH * sc / 2, used: true }); slab(rc.img.design, 'design', S.designH); }
        else layout.gaps.push({ g: i, y: y, used: false });
      }
      var top = y - eh * sc;
      if (pn && f.paneelPos.indexOf(i) !== -1) slab(paneelImg(pn, state.railColor), 'elem', eh);
      else slab(p.img, 'elem', eh);
      layout.elems.push({ i: i, yTop: top, yBottom: top + eh * sc });
    }
    slab(rc.img.end, 'end', S.railH);
    layout.height = yBase - y;
    return layout;
  }
  function drawPost(ctx, side, xCenter, yBase, heightPx, sc) {
    var pc = colorObj(state.postColor);
    var url = side === 'L' ? pc.img.postL : pc.img.postR;
    var e = imgCache[url], w = S.postW * 1.35 * sc;
    if (!e || !e.img.naturalWidth) { ctx.fillStyle = pc.hex || '#555'; ctx.fillRect(xCenter - w / 2, yBase - heightPx, w, heightPx); return; }
    var b = bboxOf(e, side === 'L' ? 'postL' : 'postR', 0);
    var capSrc = Math.round(b.h * 0.08), capH = Math.min(heightPx * 0.3, capSrc * (w / b.w));
    try {
      ctx.drawImage(e.img, b.x, b.y, b.w, capSrc, xCenter - w / 2, yBase - heightPx, w, capH);
      ctx.drawImage(e.img, b.x, b.y + capSrc, b.w, b.h - capSrc, xCenter - w / 2, yBase - heightPx + capH, w, heightPx - capH);
    } catch (err) {}
  }
  function drawGround(ctx, w, yBase) { ctx.fillStyle = 'rgba(35,31,32,.10)'; ctx.fillRect(0, yBase, w, 2); }
  function setupCanvas(cv, cssW, cssH) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(cssW * dpr); cv.height = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, cssW, cssH);
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    return ctx;
  }
  var CAP_MM = 70, PAD_MM = 60;
  var GROUND_MM = S.bodenabstand || 0; // Bodenabstand unter dem Feld
  function maxFieldHeightMm() {
    var maxEh = profiles.reduce(function (a, p) { return Math.max(a, p.elemH || S.elemH); }, S.elemH);
    return 2 * S.railH + S.maxEl * maxEh + (S.maxEl - 1) * S.designH;
  }
  var cvField = q('[data-mhzk-canvas-field]', preview), cvAll = q('[data-mhzk-canvas-all]', preview);
  var overviewEl = q('[data-mhzk-overview]', preview), loadingEl = q('[data-mhzk-loading]', preview);
  var dndEl = q('[data-mhzk-dnd]', preview), dndHint = q('[data-mhzk-dndhint]', preview);
  var overviewHits = [], fieldLayout = null;

  function renderFieldCanvas() {
    var f = state.fields[Math.max(0, state.active)];
    var cssW = cvField.parentElement.clientWidth || 500;
    var postDrawMm = S.postW * 1.35;
    var totalWmm = S.elemW + 2 * postDrawMm + 2 * PAD_MM;
    var totalHmm = maxFieldHeightMm() + GROUND_MM + CAP_MM + PAD_MM * 1.2;
    var sc = cssW / totalWmm, cssH = Math.round(totalHmm * sc);
    var ctx = setupCanvas(cvField, cssW, cssH);
    var yBase = cssH - PAD_MM * 0.6 * sc, x0 = (PAD_MM + postDrawMm) * sc;
    drawGround(ctx, cssW, yBase);
    var yField = yBase - GROUND_MM * sc;
    var lay = drawField(ctx, f, x0, yField, sc);
    drawPost(ctx, 'L', x0 - postDrawMm * sc / 2, yBase, GROUND_MM * sc + lay.height + CAP_MM * sc * 0.6, sc);
    drawPost(ctx, 'R', x0 + S.elemW * sc + postDrawMm * sc / 2, yBase, GROUND_MM * sc + lay.height + CAP_MM * sc * 0.6, sc);
    if (GROUND_MM > 0) { ctx.fillStyle = 'rgba(35,31,32,.35)'; ctx.font = '500 10px sans-serif'; ctx.textAlign = 'left'; ctx.fillText((GROUND_MM / 10) + ' cm Bodenabstand', x0 + 4, yBase - 4); }
    fieldLayout = { x0: x0, x1: x0 + S.elemW * sc, sc: sc, yBase: yBase, elems: lay.elems, gaps: lay.gaps };
    renderDnd(f);
  }
  var PER_ROW = 6; // Felder je Zeile in der Gesamtansicht
  function renderOverview() {
    var n = state.fields.length;
    if (n < 2) { overviewEl.hidden = true; return; }
    overviewEl.hidden = false;
    var availW = overviewEl.clientWidth - 28 || 500, postDrawMm = S.postW * 1.35;
    var rows = Math.ceil(n / PER_ROW), perRow = Math.min(n, PER_ROW);
    var rowWmm = perRow * S.elemW + (perRow + 1) * postDrawMm + 2 * PAD_MM;
    var sc = availW / rowWmm;
    var LABEL_PX = 26; // Platz für "Feld n" unter jeder Zeile
    var rowHmm = maxFieldHeightMm() + GROUND_MM + CAP_MM + PAD_MM * 0.6;
    var rowPx = Math.round(rowHmm * sc) + LABEL_PX;
    var cssW = Math.round(rowWmm * sc), cssH = rowPx * rows;
    var ctx = setupCanvas(cvAll, cssW, cssH);
    overviewHits = [];
    var active = Math.max(0, state.active);
    for (var r = 0; r < rows; r++) {
      var from = r * PER_ROW, to = Math.min(n, from + PER_ROW), cnt = to - from;
      var yBase = rowPx * (r + 1) - LABEL_PX, yField = yBase - GROUND_MM * sc;
      drawGround(ctx, cssW, yBase);
      var x = PAD_MM * sc + postDrawMm * sc, heights = [];
      for (var i = from; i < to; i++) {
        var f = state.fields[i];
        var h = drawField(ctx, f, x, yField, sc).height + GROUND_MM * sc;
        heights.push(h);
        overviewHits.push({ x0: x, x1: x + S.elemW * sc, y0: yBase - h - 8, y1: yBase + 20, i: i });
        if (i === active) {
          ctx.save(); ctx.strokeStyle = '#d27437'; ctx.lineWidth = 2; ctx.setLineDash([6, 4]);
          ctx.strokeRect(x - 3, yBase - h - 6, S.elemW * sc + 6, h - GROUND_MM * sc + 10); ctx.restore();
        }
        ctx.fillStyle = 'rgba(35,31,32,.6)'; ctx.font = '600 12px sans-serif'; ctx.textAlign = 'center';
        ctx.fillText('Feld ' + (i + 1), x + S.elemW * sc / 2, yBase + 16);
        x += S.elemW * sc + postDrawMm * sc;
      }
      // Pfosten der Zeile (der gemeinsame Pfosten zwischen zwei Zeilen wird an beiden Enden gezeigt)
      x = PAD_MM * sc + postDrawMm * sc;
      for (var p = 0; p <= cnt; p++) {
        var hl = p > 0 ? heights[p - 1] : (from > 0 ? heights[0] : 0), hr = p < cnt ? heights[p] : (to < n ? heights[cnt - 1] : 0);
        drawPost(ctx, p === cnt ? 'R' : 'L', x - postDrawMm * sc / 2, yBase, Math.max(hl, hr) + CAP_MM * sc * 0.6, sc);
        x += S.elemW * sc + postDrawMm * sc;
      }
      if (rows > 1) {
        ctx.fillStyle = 'rgba(35,31,32,.45)'; ctx.font = '500 11px sans-serif'; ctx.textAlign = 'right';
        ctx.fillText((to < n ? 'weiter in Zeile ' + (r + 2) + ' →' : ''), cssW - 6, yBase - 4);
      }
    }
    q('[data-mhzk-overview-hint]', preview).textContent = n + ' Felder · ' + m(totalLenMm()) + (rows > 1 ? ' · ' + rows + ' Zeilen' : '');
  }
  cvAll.addEventListener('click', function (ev) {
    var r = cvAll.getBoundingClientRect(), x = ev.clientX - r.left, y = ev.clientY - r.top;
    var hit = overviewHits.filter(function (h) { return x >= h.x0 && x <= h.x1 && y >= h.y0 && y <= h.y1; })[0];
    if (hit) { state.active = hit.i; render(); }
  });

  var renderTimer = null;
  function renderCanvases() {
    loadingEl.hidden = false;
    preload(state.fields).then(function () { renderFieldCanvas(); renderOverview(); loadingEl.hidden = true; });
  }
  var resizeT;
  window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(renderCanvases, 150); });

  /* ─────────────────── Drag & Drop (Designleisten, Dekorpaneel) ─────────────────── */
  function renderDnd(f) {
    dndEl.innerHTML = '';
    dndEl.className = 'mhzk-dnd';
    var L = fieldLayout; if (!L) return;
    var any = false;
    // Drop-Zonen
    L.gaps.forEach(function (g) {
      var z = document.createElement('div'); z.className = 'mhzk-dnd__zone mhzk-dnd__zone--gap';
      z.style.top = (g.y - 9) + 'px'; z.style.height = '18px'; z.style.left = L.x0 + 'px'; z.style.right = (dndEl.clientWidth - L.x1) + 'px';
      z.setAttribute('data-gap', g.g); z.setAttribute('data-used', g.used ? '1' : '0'); dndEl.appendChild(z);
    });
    L.elems.forEach(function (e) {
      var z = document.createElement('div'); z.className = 'mhzk-dnd__zone mhzk-dnd__zone--elem';
      z.style.top = e.yTop + 'px'; z.style.height = (e.yBottom - e.yTop) + 'px'; z.style.left = L.x0 + 'px'; z.style.right = (dndEl.clientWidth - L.x1) + 'px';
      z.setAttribute('data-elem', e.i); dndEl.appendChild(z);
    });
    // Chips
    f.designSlots.forEach(function (g) {
      var gap = L.gaps.filter(function (x) { return x.g === g; })[0]; if (!gap) return;
      var c = document.createElement('div'); c.className = 'mhzk-dnd__chip'; c.textContent = 'Designleiste';
      c.style.top = gap.y + 'px'; c.style.right = (dndEl.clientWidth - L.x1 + 6) + 'px';
      c.setAttribute('data-kind', 'design'); c.setAttribute('data-gap', g); dndEl.appendChild(c); any = true;
    });
    if (f.paneel) {
      var pn = paneelObj(f.paneel);
      f.paneelPos.forEach(function (pos) {
        var el = L.elems[pos]; if (!el || !pn) return;
        var c2 = document.createElement('div'); c2.className = 'mhzk-dnd__chip'; c2.textContent = 'Paneel ' + pn.name;
        c2.style.top = ((el.yTop + el.yBottom) / 2) + 'px'; c2.style.left = (L.x0 + 6) + 'px';
        c2.setAttribute('data-kind', 'paneel'); c2.setAttribute('data-pos', pos); dndEl.appendChild(c2); any = true;
      });
    }
    dndHint.hidden = !any;
  }
  function f0() { return state.fields[Math.max(0, state.active)]; }
  (function bindDnd() {
    var drag = null;
    dndEl.addEventListener('pointerdown', function (ev) {
      var chip = ev.target.closest('.mhzk-dnd__chip'); if (!chip) return;
      ev.preventDefault();
      chip.setPointerCapture(ev.pointerId);
      drag = { chip: chip, kind: chip.getAttribute('data-kind'), fromGap: parseInt(chip.getAttribute('data-gap'), 10), fromPos: parseInt(chip.getAttribute('data-pos'), 10), startY: ev.clientY, top: parseFloat(chip.style.top), over: null };
      chip.classList.add('is-dragging');
      dndEl.classList.add(drag.kind === 'design' ? 'is-dragging-design' : 'is-dragging-paneel');
    });
    dndEl.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      var dy = ev.clientY - drag.startY;
      drag.chip.style.top = (drag.top + dy) + 'px';
      var r = dndEl.getBoundingClientRect(), y = ev.clientY - r.top;
      var zones = qa(drag.kind === 'design' ? '.mhzk-dnd__zone--gap' : '.mhzk-dnd__zone--elem', dndEl);
      var best = null, bestD = 1e9;
      zones.forEach(function (z) {
        z.classList.remove('is-over');
        if (drag.kind === 'design' && z.getAttribute('data-used') === '1' && parseInt(z.getAttribute('data-gap'), 10) !== drag.fromGap) return;
        if (drag.kind === 'paneel') { var pe = parseInt(z.getAttribute('data-elem'), 10); if (pe !== drag.fromPos && f0().paneelPos.indexOf(pe) !== -1) return; }
        var zt = parseFloat(z.style.top), zh = parseFloat(z.style.height), c = zt + zh / 2, d = Math.abs(y - c);
        if (drag.kind === 'paneel' ? (y >= zt && y <= zt + zh) : d < 24) { if (d < bestD) { bestD = d; best = z; } }
      });
      if (best) best.classList.add('is-over');
      drag.over = best;
    });
    function end(ev) {
      if (!drag) return;
      var f = state.fields[Math.max(0, state.active)], z = drag.over, changed = false;
      if (z) {
        if (drag.kind === 'design') {
          var to = parseInt(z.getAttribute('data-gap'), 10);
          if (to !== drag.fromGap) { f.designSlots = f.designSlots.filter(function (g) { return g !== drag.fromGap; }).concat([to]); changed = true; }
        } else {
          var toEl = parseInt(z.getAttribute('data-elem'), 10);
          if (toEl !== drag.fromPos && f.paneelPos.indexOf(toEl) === -1) { f.paneelPos = f.paneelPos.filter(function (g) { return g !== drag.fromPos; }).concat([toEl]); changed = true; }
        }
      }
      drag.chip.classList.remove('is-dragging');
      dndEl.classList.remove('is-dragging-design', 'is-dragging-paneel');
      drag = null;
      if (changed) {
        normalizeField(f, false);
        if (state.same) state.fields.forEach(function (o) { if (o !== f) copyInto(o, f); });
        f.saved = false; render();
      } else renderDnd(f);
    }
    dndEl.addEventListener('pointerup', end);
    dndEl.addEventListener('pointercancel', end);
  })();

  /* ─────────────────── UI ─────────────────── */
  var els = {
    len: q('[data-mhzk-len]'), fieldsRange: q('[data-mhzk-fields]'), dec: q('[data-mhzk-fields-dec]'), inc: q('[data-mhzk-fields-inc]'),
    tFields: q('[data-mhzk-t-fields]'), tPosts: q('[data-mhzk-t-posts]'), tLen: q('[data-mhzk-t-len]'),
    postcolors: q('[data-mhzk-postcolors]'), postcolorName: q('[data-mhzk-postcolor-name]'),
    same: q('[data-mhzk-same]'), fieldList: q('[data-mhzk-fieldlist]'), panelAnchor: q('[data-mhzk-panel-anchor]'), panel: q('[data-mhzk-field]'),
    profile: q('[data-mhzk-profile]'), profilName: q('[data-mhzk-profil-name]'),
    heightRow: q('[data-mhzk-height-row]'), heightVal: q('[data-mhzk-height-val]'), elements: q('[data-mhzk-elements]'),
    designWrap: q('[data-mhzk-design-wrap]'), designRange: q('[data-mhzk-design-range]'), designVal: q('[data-mhzk-design-val]'),
    paneelWrap: q('[data-mhzk-paneel-wrap]'), paneel: q('[data-mhzk-paneel]'), paneelRange: q('[data-mhzk-paneel-range]'), paneelRangeWrap: q('[data-mhzk-paneel-range-wrap]'), paneelVal: q('[data-mhzk-paneel-val]'),
    railWrap: q('[data-mhzk-railcolor-wrap]'), railcolors: q('[data-mhzk-railcolors]'), railName: q('[data-mhzk-railcolor-name]'),
    fieldActions: q('[data-mhzk-field-actions]'), applyAll: q('[data-mhzk-apply-all]'), saveField: q('[data-mhzk-save-field]'),
    setlist: q('[data-mhzk-setlist]'), list: q('[data-mhzk-list]'), final: q('[data-mhzk-final]'), save: q('[data-mhzk-save]'),
    cta: q('[data-mhzk-cta]'), err: q('[data-mhzk-err]'),
    stageTitle: q('[data-mhzk-stage-title]', preview), stageDims: q('[data-mhzk-stage-dims]', preview)
  };
  els.fieldsRange.max = S.maxFields || 26;
  els.elements.classList.add('mhzk__pills--grid');

  function pill(val, label, active, disabled, sub) {
    return '<button type="button" class="mhzk__pill' + (active ? ' is-active' : '') + '" data-val="' + esc(val) + '" role="radio" aria-checked="' + (active ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') + '>' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</button>';
  }
  function swatch(c, active) {
    return '<button type="button" class="mhzk__swatch' + (active ? ' is-active' : '') + '" data-val="' + esc(c.handle) + '" role="radio" aria-checked="' + (active ? 'true' : 'false') + '"><i style="background:' + esc(c.hex) + '"></i>' + esc(c.name) + '</button>';
  }
  function profileBtn(p, active) {
    return '<button type="button" class="mhzk__profile-btn' + (active ? ' is-active' : '') + '" data-val="' + esc(p.handle) + '" role="radio" aria-checked="' + (active ? 'true' : 'false') + '"><i class="' + (p.material === 'alu' ? 'is-alu' : '') + '" style="background:' + esc(p.hex) + '"></i>' + esc(p.name) + '</button>';
  }
  function bindGroup(container, onPick) {
    container.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-val]'); if (!b || b.disabled) return;
      onPick(b.getAttribute('data-val'));
    });
  }
  function updateField(mut, recalcSlots) {
    if (state.active < 0) state.active = 0;
    var f = state.fields[state.active];
    mut(f); normalizeField(f, !!recalcSlots); f.saved = false;
    if (state.same) state.fields.forEach(function (o) { if (o !== f) { copyInto(o, f); o.saved = false; } });
    render();
  }
  function setFieldCount(n) {
    n = clamp(n, 1, parseInt(els.fieldsRange.max, 10));
    var tpl = state.fields[state.fields.length - 1];
    while (state.fields.length < n) state.fields.push(newField(tpl));
    while (state.fields.length > n) state.fields.pop();
    if (state.active >= n) state.active = n - 1;
    render();
  }

  els.fieldsRange.addEventListener('input', function () { setFieldCount(parseInt(els.fieldsRange.value, 10)); });
  els.dec.addEventListener('click', function () { setFieldCount(state.fields.length - 1); });
  els.inc.addEventListener('click', function () { setFieldCount(state.fields.length + 1); });
  qa('[data-mhzk-mount]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.montage = b.getAttribute('data-mhzk-mount');
      qa('[data-mhzk-mount]').forEach(function (x) { var a = x === b; x.classList.toggle('is-active', a); x.setAttribute('aria-checked', a ? 'true' : 'false'); });
      render();
    });
  });
  bindGroup(els.postcolors, function (v) { state.postColor = v; render(); });
  els.same.addEventListener('change', function () {
    state.same = els.same.checked;
    if (state.same) { var a = state.fields[Math.max(0, state.active)]; state.fields.forEach(function (o) { if (o !== a) copyInto(o, a); }); }
    render();
  });
  els.fieldList.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-idx]'); if (!b) return;
    var idx = parseInt(b.getAttribute('data-idx'), 10);
    if (idx === state.active && state.fields.length > 1) { state.active = -1; render(); return; } // zuklappen
    state.active = idx; render();
  });
  bindGroup(els.profile, function (v) { updateField(function (f) { f.profil = v; }, true); });
  bindGroup(els.elements, function (v) { updateField(function (f) { f.el = parseInt(v, 10); }, true); });
  els.designRange.addEventListener('input', function () { var v = parseInt(els.designRange.value, 10) || 0; updateField(function (f) { f.designN = v; }, true); });
  bindGroup(els.paneel, function (v) { updateField(function (f) { f.paneel = v === '' ? null : v; if (f.paneel && !f.paneelN) f.paneelN = 1; if (!f.paneel) f.paneelN = 0; }, false); });
  els.paneelRange.addEventListener('input', function () { var v = parseInt(els.paneelRange.value, 10) || 0; updateField(function (f) { f.paneelN = v; if (v > 0 && !f.paneel) f.paneel = (D.paneele[0] || {}).handle; }, true); });
  bindGroup(els.railcolors, function (v) { state.railColor = v; state.fields.forEach(function (o) { o.saved = false; }); render(); });
  els.applyAll.addEventListener('click', function () {
    var a = state.fields[Math.max(0, state.active)];
    state.fields.forEach(function (o) { if (o !== a) copyInto(o, a); o.saved = true; });
    render();
  });
  els.saveField.addEventListener('click', function () {
    if (state.active < 0) state.active = 0;
    state.fields[state.active].saved = true;
    if (state.active < state.fields.length - 1) state.active++;
    render();
  });

  function shortSummary(x) {
    var pr = profOf(x.profil) || {}, parts = [pr.name, isLamellen(x) ? pr.lamellen + ' Lamellen' : x.el + ' Elemente'];
    if (designCount(x)) parts.push(designCount(x) + ' Designl.');
    if (x.paneel && x.paneelPos.length) parts.push(x.paneelPos.length + '× ' + (paneelObj(x.paneel) || {}).name);
    return parts.join(' · ');
  }
  function render() {
    var n = state.fields.length;
    if (state.active >= n) state.active = n - 1;
    var f = state.fields[Math.max(0, state.active)], p = profOf(f.profil) || {};
    els.fieldsRange.value = n;
    els.len.textContent = n + (n === 1 ? ' Feld' : ' Felder') + ' · ' + m(totalLenMm());
    els.tFields.textContent = n; els.tPosts.textContent = n + 1; els.tLen.textContent = m(totalLenMm());

    // Pfostenfarbe
    var pc = colorObj(state.postColor);
    els.postcolors.innerHTML = farben.map(function (c) { return swatch(c, c.handle === state.postColor); }).join('');
    els.postcolorName.textContent = pc.name || '';

    // Felder als aufklappbare Abschnitte (nur wenn nicht "alle gleich")
    var accordion = !state.same && n > 1;
    els.fieldList.hidden = !accordion;
    els.fieldActions.hidden = !accordion;
    if (accordion) {
      var accKey = n + '|' + state.active;
      if (els.fieldList.getAttribute('data-key') !== accKey) { els.fieldList.setAttribute('data-key', accKey); els.fieldList.innerHTML = state.fields.map(function (x, i) {
        var open = i === state.active;
        return '<div class="mhzk__acc' + (open ? ' is-open' : '') + '" data-acc="' + i + '"><button type="button" class="mhzk__acc-head" data-idx="' + i + '" aria-expanded="' + open + '"><span class="mhzk__acc-title' + (x.saved ? ' is-saved' : '') + '">Feld ' + (i + 1) + '</span><span class="mhzk__acc-sum">' + esc(shortSummary(x)) + '</span><span class="mhzk__acc-chev"></span></button><div class="mhzk__acc-body"></div></div>';
      }).join(''); }
      // Kopfzeilen aktualisieren, ohne die Liste neu aufzubauen (sonst bricht ein laufender Slider-Drag ab)
      qa('.mhzk__acc', els.fieldList).forEach(function (acc, i) {
        var x = state.fields[i]; if (!x) return;
        var sum = acc.querySelector('.mhzk__acc-sum'), title = acc.querySelector('.mhzk__acc-title');
        if (sum) sum.textContent = shortSummary(x);
        if (title) title.classList.toggle('is-saved', !!x.saved);
      });
      var body = els.fieldList.querySelector('.mhzk__acc[data-acc="' + state.active + '"] .mhzk__acc-body');
      if (body) { if (els.panel.parentNode !== body) body.appendChild(els.panel); }
      else if (els.panel.nextSibling !== els.panelAnchor) els.panelAnchor.parentNode.insertBefore(els.panel, els.panelAnchor);
      els.panel.hidden = !body;
    } else {
      els.fieldList.innerHTML = ''; els.fieldList.removeAttribute('data-key');
      if (els.panel.nextSibling !== els.panelAnchor) els.panelAnchor.parentNode.insertBefore(els.panel, els.panelAnchor);
      els.panel.hidden = false;
      if (state.active < 0) state.active = 0;
    }
    if (state.active < 0) { // alles zugeklappt: Vorschau zeigt Feld 1
      f = state.fields[0]; p = profOf(f.profil) || {};
    }

    // Profil & Farbe (gruppiert nach Material)
    var groups = [{ key: 'wpc', label: 'WPC' }, { key: 'alu', label: 'Aluminium' }];
    els.profile.innerHTML = groups.map(function (g) {
      var list = profiles.filter(function (x) { return (x.material || 'wpc') === g.key; });
      if (!list.length) return '';
      return '<div><div class="mhzk__profile-group-label">' + g.label + '</div><div class="mhzk__profile-list">' + list.map(function (x) { return profileBtn(x, x.handle === f.profil); }).join('') + '</div></div>';
    }).join('');
    els.profilName.textContent = p.name || '';

    // Höhe (zweizeilig, ausgeschrieben)
    var fx = fixedElements(f);
    var opts = [];
    for (var e = S.minEl; e <= S.maxEl; e++) opts.push(pill(e, e + ' Elemente', e === f.el, !!fx && e !== fx, 'ca. ' + m(2 * S.railH + e * elemH(f))));
    if (fx) {
      var lam = isLamellen(f) ? p.lamellen + ' Lamellen à ' + p.lamellenH + ' mm mit Abstandshaltern' : fx + ' Elemente';
      els.elements.innerHTML = '<p class="mhzk__note" style="grid-column:1/-1;margin:0">' + esc(p.name) + ' wird als fertiges Feld-Set geliefert (' + esc(lam) + ', inkl. Start-/Abschlussleiste) – Höhe ca. ' + m(fieldHeightMm(f)) + ', nicht veränderbar.</p>';
      els.heightVal.textContent = (isLamellen(f) ? p.lamellen + ' Lamellen' : fx + ' Elemente') + ' · ca. ' + m(fieldHeightMm(f));
    } else {
      els.elements.innerHTML = opts.join('');
      els.heightVal.textContent = f.el + ' Elemente · ca. ' + m(fieldHeightMm(f));
    }

    // Designleisten
    var lamellen = isLamellen(f);
    els.designWrap.hidden = !hasDesign || lamellen;
    if (hasDesign && !lamellen) {
      els.designRange.max = Math.max(0, f.el - 1); if (String(els.designRange.value) !== String(f.designN)) els.designRange.value = f.designN;
      var dm = q('[data-mhzk-design-max]'); if (dm) dm.textContent = Math.max(0, f.el - 1);
      els.designVal.textContent = designCount(f) ? designCount(f) + ' von ' + (f.el - 1) + ' · Position per Ziehen in der Vorschau' : 'keine';
    }
    // Paneel
    els.paneelWrap.hidden = !hasPaneele || lamellen;
    if (hasPaneele && !lamellen) {
      els.paneel.innerHTML = [pill('', 'Ohne', !f.paneel)].concat(D.paneele.map(function (x) { return pill(x.handle, x.name, x.handle === f.paneel); })).join('');
      els.paneelRangeWrap.hidden = !f.paneel;
      els.paneelRange.max = f.el; els.paneelRange.min = 1; if (String(els.paneelRange.value) !== String(f.paneelN)) els.paneelRange.value = f.paneelN;
      var pm = q('[data-mhzk-paneel-max]'); if (pm) pm.textContent = f.el;
      els.paneelVal.textContent = f.paneel ? (f.paneelN + '× ' + (paneelObj(f.paneel) || {}).name + ' · Pos. ' + f.paneelPos.slice().sort(function (a, b) { return b - a; }).map(function (g) { return f.el - g; }).join('/') + ' von oben, per Ziehen verschiebbar') : 'ohne';
    }
    // Leistenfarbe
    var showRail = state.fields.some(function (o) { return (hasRailsProduct && !fieldRailsFromSet(o)) || designCount(o) > 0 || !!o.paneel; });
    els.railWrap.hidden = !showRail;
    els.railcolors.innerHTML = farben.map(function (c) { return swatch(c, c.handle === state.railColor); }).join('');
    els.railName.textContent = colorObj(state.railColor).name || '';

    // Stückliste + Preis
    var bom = buildBom();
    els.setlist.innerHTML = bom.lines.map(function (l) {
      return '<li class="mhzk__set-row' + (l.available ? '' : ' is-unavailable') + '"><span>' + esc(l.title) + (l.available ? '' : ' (nicht verfügbar)') + '</span><span><span class="mhzk__set-price">' + money(l.q * l.price) + '</span> &nbsp;<b>' + l.q + '×</b></span></li>';
    }).join('') + (bom.spare > 0 ? '<li class="mhzk__set-row"><span style="color:rgba(35,31,32,.55)">WPC-Profile werden in Sets geliefert – ' + bom.spare + (bom.spare > 1 ? ' Profile bleiben' : ' Profil bleibt') + ' als Reserve.</span></li>' : '');
    els.final.textContent = money(bom.total);
    if (bom.compare > bom.total + 1) { els.list.hidden = false; els.list.textContent = money(bom.compare); els.save.textContent = 'du sparst ' + money(bom.compare - bom.total); }
    else { els.list.hidden = true; els.save.textContent = ''; }
    var ok = !bom.problems.length && !bom.unavailable && bom.lines.length > 0;
    els.cta.disabled = !ok;
    els.err.hidden = ok;
    els.err.textContent = bom.problems.length ? bom.problems.join(' · ') : (bom.unavailable ? 'Eine Komponente ist derzeit nicht verfügbar.' : '');
    root._bom = bom;

    var s2 = q('[data-mhzk-step2-sum]'); if (s2) s2.textContent = (state.montage === 'einbetonieren' ? 'Einbetonieren' : 'Aufschrauben') + ' · Pfosten ' + (pc.name || '') + (els.railWrap && !els.railWrap.hidden ? ' · Leisten ' + (colorObj(state.railColor).name || '') : '');
    var s3 = q('[data-mhzk-step3-sum]'); if (s3) s3.textContent = state.same ? shortSummary(f) : n + ' Felder einzeln';
    els.stageTitle.textContent = (state.same && n > 1) ? 'Zaunfeld (alle gleich)' : 'Zaunfeld ' + (Math.max(0, state.active) + 1) + ' von ' + n;
    els.stageDims.textContent = (p.name || '') + ' · ' + m(S.elemW) + ' × ' + m(fieldHeightMm(f));

    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderCanvases, 30);
  }

  /* ─────────────────── Warenkorb ─────────────────── */
  function fieldSummary(f, i) {
    var p = profOf(f.profil) || {};
    var parts = [p.name, (isLamellen(f) ? p.lamellen + ' Lamellen' : f.el + ' Elemente') + ' (' + m(fieldHeightMm(f)) + ')'];
    if (designCount(f)) parts.push(designCount(f) + ' Designl. (Pos. ' + f.designSlots.map(function (g) { return f.el - g; }).sort(function (a, b) { return a - b; }).join('/') + ' v. oben)');
    if (f.paneel && f.paneelPos.length) parts.push(f.paneelPos.length + '× ' + (paneelObj(f.paneel) || {}).name + ' (Pos. ' + f.paneelPos.slice().sort(function (a, b) { return b - a; }).map(function (g) { return f.el - g; }).join('/') + ' v. oben)');
    return 'F' + (i + 1) + ': ' + parts.join(', ');
  }
  els.cta.addEventListener('click', function () {
    var bom = root._bom; if (!bom || !bom.lines.length) return;
    var n = state.fields.length;
    var cfgId = 'ZK-' + Date.now().toString(36).toUpperCase();
    var summary = n + (n === 1 ? ' Feld' : ' Felder') + ' · ' + m(totalLenMm()) + ' · ' + (state.montage === 'einbetonieren' ? 'Einbetonieren' : 'Aufschrauben') + ' · Pfosten ' + (colorObj(state.postColor).name || '') + ' · Leisten ' + (colorObj(state.railColor).name || '');
    var felder = state.same ? fieldSummary(state.fields[0], 0).replace(/^F1:/, 'Alle Felder:') : state.fields.map(fieldSummary).join(' | ');
    var props = { 'Konfiguration': summary, 'Zaunfelder': felder, '_mh_konfig_id': cfgId };
    var items = bom.lines.map(function (l) { return { id: l.id, quantity: l.q, properties: props }; });
    var original = els.cta.textContent;
    els.cta.disabled = true; els.cta.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () {
        els.cta.disabled = false; els.cta.textContent = original;
        if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        else window.location.href = '/cart';
      })
      .catch(function (e) {
        els.cta.disabled = false; els.cta.textContent = original;
        els.err.hidden = false; els.err.textContent = (e && (e.description || e.message)) || 'Konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.';
      });
  });

  /* ─────────────────── Platzierung in der Buy-Box ─────────────────── */
  (function place() {
    var info = document.querySelector('#ProductInfo-' + sectionId + ' .product__blocks');
    if (!info) return;
    var target = info.querySelector('.product__block--title') || info.querySelector('.product__block--ProductFeatures');
    if (target) target.parentNode.insertBefore(root, target.nextSibling);
    else info.insertBefore(root, info.firstChild);
  })();

  render();
})();
